"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hawaComponents = require("hawa-components");
var _advancedFetch = _interopRequireDefault(require("../../lib/advanced-fetch"));
var _translate = _interopRequireDefault(require("../translate"));
var _productSubtypeSelector = _interopRequireDefault(require("../product-subtype-selector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var mapConfiguratorEntry = function mapConfiguratorEntry(t) {
  return function (configurator) {
    configurator.label = t(configurator.key);
    configurator.subLabel = t("".concat(configurator.key, " sub"));
    return configurator;
  };
};
var HomePage = /*#__PURE__*/function (_React$Component) {
  _inherits(HomePage, _React$Component);
  function HomePage(props) {
    var _this;
    _classCallCheck(this, HomePage);
    _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this, props));
    _this.state = {
      hostname: location.hostname,
      loaded: false,
      component: '',
      description: {}
    };
    _this.goToTarget = _this.goToTarget.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HomePage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (prevProps.lng !== this.props.lng) {
        this.setState(function (prev) {
          if (prev.component === 'type') {
            prev.productData = prev.productData.map(mapConfiguratorEntry(_this2.props.t));
          }
          return prev;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("article", {
        className: 'comp-home-page'
      }, this.state.component === 'type' && this.state.loaded ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("section", {
        className: 'grid-x relative-grid'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: 'heading--main'
      }, t('HAWA Concepta Planning tool')))), /*#__PURE__*/_react.default.createElement(_hawaComponents.ProductTypeSelector, {
        productTypes: this.state.productData,
        texts: {
          pleaseChoose: t('Please choose')
        },
        classNames: 'small-up-1 medium-up-2 large-up-3',
        save: function save(selection) {
          return _this3.goToTarget(selection.type);
        }
      })) : '', this.state.component === 'subtype' && this.state.loaded ? /*#__PURE__*/_react.default.createElement(_productSubtypeSelector.default, {
        description: this.state.description,
        productData: this.state.productData,
        rootPage: this.state.rootPage
      }) : '');
    }
  }, {
    key: "load",
    value: function load() {
      var _this4 = this;
      var t = this.props.t;
      fetch('/api/rendering', {
        credentials: 'include'
      }).then(_advancedFetch.default).then(function (response) {
        _this4.setState(function (prev) {
          prev.component = response.component;
          prev.productData = response.productData;
          prev.description = response.description;
          prev.rootPage = response.rootPage;
          prev.loaded = true;
          if (response.component === 'type') {
            prev.productData = response.productData.map(mapConfiguratorEntry(t));
          }
          return prev;
        });
      }).catch(function (err) {
        if (err.status !== 404) {
          void 0;
        }
      });
    }
  }, {
    key: "goToTarget",
    value: function goToTarget(target) {
      var configuratorIndex = this.state.productData.findIndex(function (configurator) {
        return configurator.key === target;
      });
      if (configuratorIndex === -1) {
        void 0;
      }
      window.location.href = this.state.productData[configuratorIndex].link;
    }
  }]);
  return HomePage;
}(_react.default.Component);
HomePage.propTypes = {
  t: _propTypes.default.func.isRequired,
  lng: _propTypes.default.string
};
var _default = (0, _translate.default)(HomePage);
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/home-page/index.js
// module id = 413
// module chunks = 0